import {
	events,
	items,
	randomEvents,
	seasonalEvents,
	villagers
} from '../services'
import { Data } from '../types'

export const data: Data = {
	events,
	items,
	randomEvents,
	seasonalEvents,
	villagers
}